// MEMO: 1000단위마다 콤마로 구분짓기
export function comma(num: number) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
